import React from "react";
import PropTypes from "prop-types";

function CheckmarkLarge({
  className,
  style,
  fill,
  defaultWidth,
  defaultHeight
}) {
  return (
    <svg
      viewBox="0 0 140 140"
      width={style && style.width ? style.width : defaultWidth}
      height={style && style.width ? style.height : defaultHeight}
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3 3)" fill="none" fill-rule="evenodd">
        <circle stroke="#28EBC1" stroke-width="5" cx="67" cy="67" r="67" />
        <path
          d="M102.755414 41.587276L56.572016 88.378015l-16.32743-16.542147c-.77287-.783034-2.026023-.783034-2.799059 0l-1.865874 1.890412c-.77287.783034-.77287 2.052667 0 2.835868L55.17257 96.412724c.77287.783035 2.026023.783035 2.799058 0l49.448719-50.099001c.772871-.783035.772871-2.052667 0-2.835868l-1.866039-1.89058c-.772871-.783034-2.026023-.783034-2.798894 0z"
          fill={fill}
          fill-rule="nonzero"
        />
      </g>
    </svg>
  );
}

CheckmarkLarge.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  fill: PropTypes.string
};

CheckmarkLarge.defaultProps = {
  className: undefined,
  defaultHeight: 140,
  defaultWidth: 140,
  fill: "#28EBC1"
};

export default CheckmarkLarge;
